import React from 'react';
import { motion } from 'framer-motion';

interface ProductImageProps {
  src: string;
  alt: string;
}

export const ProductImage: React.FC<ProductImageProps> = ({ src, alt }) => {
  const [isLoaded, setIsLoaded] = React.useState(false);

  return (
    <div className="relative h-48 bg-gray-100">
      {!isLoaded && (
        <div className="absolute inset-0 animate-pulse bg-gray-200" />
      )}
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        onLoad={() => setIsLoaded(true)}
        loading="lazy"
      />
    </div>
  );
};